import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { errorMessage } from 'constants/CommonConstants';
import { formRequiredRules } from 'helper';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { InputRadio } from 'sharedComponents/inputGroup/InputRadio';
import { TRADE_IN } from '../DigitalRetailingConstant';
import VehicleDetails from './sub-component/VehicleDetails';
import { useSelector } from 'react-redux';

const Step2: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  // Hooks
  const { t } = useTranslation();

  // React Hook Form
  const { control, trigger, getValues } = useFormContext();

  const hasCalledNextStep = React.useRef(false);

  // React Hook Form Trigger
  const nextStep = async () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { tradeInOption } = getValues();

    tradeInOption && onNext?.(tradeInOption == 'Yes' ? 2 : 6);
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <div className='dr-widget-steps with-sidebar step-2'>
      <div className='dr-widget-steps__content'>
        <h2 className='dr-widget-steps__title'>{t('digitalRetailing.timeSaveAtDealership')}</h2>
        <p className='dr-widget-steps__step-note text-secondary'>{t('digitalRetailing.note2')}</p>
        <div className='dr-radio-style'>
          <InputRadio
            name={'tradeInOption'}
            control={control}
            options={TRADE_IN(t)}
            rules={formRequiredRules(errorMessage(t).radioError)}
            triggerValidationForField={(name: string, val: string) => {
              trigger(name);
              onNext?.(val == 'Yes' ? 2 : 6);
            }}
          />
        </div>
      </div>
      <VehicleDetails />
    </div>
  );
};

const StepperForm2 = React.forwardRef(Step2);

export default StepperForm2;
